import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const StackIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M10.8 1.3a3 3 0 0 1 2.4 0l8.6 3.9a2 2 0 0 1 0 3.6l-8.5 4a3 3 0 0 1-2.5 0l-8.6-4a2 2 0 0 1 0-3.6l8.6-4ZM12 3a1 1 0 0 0-.4 0L3 7l8.6 4a1 1 0 0 0 .8 0L21 7l-8.6-4a1 1 0 0 0-.4 0ZM1 17.2a1 1 0 0 1 1.4-.5l9.2 4.2a1 1 0 0 0 .8 0l9.2-4.2a1 1 0 1 1 .8 1.9l-9.2 4.1a3 3 0 0 1-2.4 0l-9.2-4.1a1 1 0 0 1-.5-1.4Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M1 12.2a1 1 0 0 1 1.4-.5l9.2 4.2a1 1 0 0 0 .8 0l9.2-4.2a1 1 0 0 1 .8 1.9l-9.2 4.1a3 3 0 0 1-2.4 0l-9.2-4.1a1 1 0 0 1-.5-1.4Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default StackIcon;
